// bm-tests.provider.ts (inside BM package)
import {Provider} from '@angular/core';
import {
    BmCustomerBillingAccountTransactionObjectComponent
} from "../component/object-components/bm-customer-billing-account-transaction-object-component/bm-customer-billing-account-transaction-object.component";

import {
    BmCustomerAccountObjectComponent
} from "../component/object-components/bm-customer-account-object-component/bm-customer-account-object.component";
import {
    TEST_MODULE_REGISTRY,
    TestCaseDataType,
    TestModuleDefinition
} from "../../../core/shared/test/data/test-harness.types";
import {
    BmAccountInfoComponent
} from "../component/protected-components/bm-account-info-component/bm-account-info.component";
import {
    BmBillingRunDetailedReportComponent
} from "../component/protected-components/bm-billing-run-detailed-report-component/bm-billing-run-detailed-report.component";
import {
    BmBillingRunDetailsComponent
} from "../component/protected-components/bm-billing-run-details-component/bm-billing-run-details.component";
import {
    BmBillingRunObjectComponent
} from "../component/protected-components/bm-billing-run-object-component/bm-billing-run-object.component";
import {
    BmBillingRunsComponent
} from "../component/protected-components/bm-billing-runs-component/bm-billing-runs.component";
import {
    BmBillingRunStatusFlowComponent
} from "../component/protected-components/bm-billing-run-status-flow-component/bm-billing-run-status-flow.component";
import {
    BmContractPaymentCalculatorBillingRunComponent
} from "../component/protected-components/bm-contract-payment-calculator-billing-run/bm-contract-payment-calculator-billing-run.component";
import {
    BmContractPaymentCalculatorDataComponent
} from "../component/protected-components/bm-contract-payment-calculator-data/bm-contract-payment-calculator-data.component";
import {
    BmContractPaymentCalculatorSimulationComponent
} from "../component/protected-components/bm-contract-payment-calculator-simulation/bm-contract-payment-calculator-simulation.component";
import {
    BmCreditorDetailsComponent
} from "../component/protected-components/bm-creditor-details-component/bm-creditor-details.component";
import {
    BmBankInfoCardComponent
} from "../component/protected-components/bm-bank-info-card-component/bm-bank-info-card.component";
import {
    BmContractPaymentCalculatorComponent
} from "../component/protected-components/bm-contract-payment-calculator/bm-contract-payment-calculator.component";
import * as DunningReminderTestDataA
    from "../component/protected-components/bm-customer-billing-dunning-remainder/test/data/mock-testA.json";
import * as DunningReminderTestDataB
    from "../component/protected-components/bm-customer-billing-dunning-remainder/test/data/mock-testB.json";
import {
    BmCustomerBillingDunningRemainderTestComponent
} from "../component/protected-components/bm-customer-billing-dunning-remainder/test/component/bm-customer-billing-dunning-remainder-test.component";
import {
    BmPaymentPlanTestComponent
} from "../activity/payment-plan/component/bm-payment-plan-test-component/bm-payment-plan-test.component";
import {MOCK_DUNNING_DATA_1} from "../activity/payment-plan/mock/mock-dunning-data-1";
import {MOCK_DUNNING_DATA_3} from "../activity/payment-plan/mock/mock-dunning-data-3";
import {MOCK_DUNNING_DATA_2} from "../activity/payment-plan/mock/mock-dunning-data-2";
import {MOCK_DUNNING_DATA_4} from "../activity/payment-plan/mock/mock-dunning-data-4";
import {
    BmContractPaymentPlannedTestComponent
} from "../component/protected-components/bm-contract-payment-planned/test/component/bm-contract-payment-planned-test.component";
import * as contractPaymentPlannedTestA
    from "../component/protected-components/bm-contract-payment-planned/test/data/mock-testA.json";
import * as contractPaymentPlannedTestB
    from "../component/protected-components/bm-contract-payment-planned/test/data/mock-testB.json";
import {
    CustomerBillingAccountDunningAssignPaymentsTestComponent
} from "../component/protected-components/customer-billing-account-dunning/test/component/customer-billing-account-dunning-assign-payments-test.component";
import * as DunningAssignPaymentTestDataA
    from "../component/protected-components/customer-billing-account-dunning/test/data/mock-testA.json";

// import other BM components you want to expose…

const bmModuleEntry: TestModuleDefinition = {
    key: 'bm',
    label: 'Billing (bm)',
    components: [
        {
            key: 'BmCustomerAccountObjectComponent',
            component: BmCustomerAccountObjectComponent,
            selector: 'bm-customer-account-object-component',
            type: 'ObjectBaseComponent',
            label: 'Account Account Component',
        },
        {
            key: 'BmCustomerBillingAccountTransactionObjectComponent',
            component: BmCustomerBillingAccountTransactionObjectComponent,
            selector: 'bm-customer-billing-account-transaction-object-component',
            type: 'ObjectBaseComponent',
            label: 'Customer Billing Account Transaction Object Component',

        },
        {
            key: 'BmAccountInfoComponent',
            component: BmAccountInfoComponent,
            selector: 'bm-account-info',
            type: 'Component',
            label: 'Account Info Component',
        },
        {
            key: 'BmBankInfoCardComponent',
            component: BmBankInfoCardComponent,
            selector: 'bm-bank-info-card-component',
            type: 'Component',
            label: 'Bank Info Card Component',
        },
        {
            key: 'BmBillingRunDetailedReportComponent',
            component: BmBillingRunDetailedReportComponent,
            selector: 'bm-billing-run-detailed-report-component',
            type: 'Component',
            label: 'Billing Run Detailed Report Component',
        },
        {
            key: 'BmBillingRunDetailsComponent',
            component: BmBillingRunDetailsComponent,
            selector: 'bm-billing-run-details-component',
            type: 'Component',
            label: 'Billing Run Details Component',
        },
        {
            key: 'BmContractPaymentCalculatorComponent',
            component: BmContractPaymentCalculatorComponent,
            selector: 'bm-contract-payment-calculator',
            type: 'Component',
            label: 'Billing Contract Payment Calculator Component',
        },
        {
            key: 'BmBillingRunObjectComponent',
            component: BmBillingRunObjectComponent,
            selector: 'bm-billing-run-object-component',
            type: 'ObjectBaseComponent',
            label: 'Billing Run Object Component',
        },
        {
            key: 'BmBillingRunsComponent',
            component: BmBillingRunsComponent,
            selector: 'bm-billing-runs-component',
            type: 'Component',
            label: 'Billing Runs Component',
        },
        {
            key: 'BmBillingRunStatusFlowComponent',
            component: BmBillingRunStatusFlowComponent,
            selector: 'bm-billing-run-status-flow',
            type: 'Component',
            label: 'Billing Run Status Flow Component',
        },
        {
            key: 'BmContractPaymentCalculatorBillingRunComponent',
            component: BmContractPaymentCalculatorBillingRunComponent,
            selector: 'bm-contract-payment-calculator-billing-run',
            type: 'Component',
            label: 'Billing Contract Payment Calculator Billing Run Component',
        },
        {
            key: 'BmContractPaymentCalculatorDataComponent',
            component: BmContractPaymentCalculatorDataComponent,
            selector: 'bm-contract-payment-calculator-data',
            type: 'Component',
            label: 'Billing Contract Payment Calculator Data Component',
        },
        {
            key: 'BmContractPaymentCalculatorSimulationComponent',
            component: BmContractPaymentCalculatorSimulationComponent,
            selector: 'bm-contract-payment-calculator-simulation',
            type: 'Component',
            label: 'Billing Payment Calculator Simulation Component',
        },

        {
            key: 'BmCreditorDetailsComponent',
            component: BmCreditorDetailsComponent,
            selector: 'bm-creditor-details-component',
            type: 'Component',
            label: 'Billing Creditor Details Component',
        },
        {
            key: 'BmCustomerBillingDunningRemainderTestComponent',
            component: BmCustomerBillingDunningRemainderTestComponent,
            selector: 'bm-customer-billing-dunning-remainder-test',
            type: 'Component',
            label: 'Bm Customer Billing Dunning Remainder Test',
            testCases: [
                {
                    key: 'local-basic-a',
                    label: 'Local – Basic',
                    description: 'Local JSON test data A',
                    testCaseData: [
                        {
                            id: 1,
                            name: 'Case A',
                            json: JSON.stringify(DunningReminderTestDataA),
                            dataType: 0,
                            type: TestCaseDataType.local,
                        }
                    ]
                },
                {
                    key: 'local-basic-b',
                    label: 'Local – Basic',
                    description: 'Local JSON test data B',
                    testCaseData: [
                        {
                            id: 2,
                            name: 'Case B',
                            json: JSON.stringify(DunningReminderTestDataB),
                            dataType: 0,
                            type: TestCaseDataType.local,
                        }
                    ]
                },
            ] as any
        },
        {
            key: 'BmContractPaymentPlannedTestComponent',
            component: BmContractPaymentPlannedTestComponent,
            selector: 'bm-contract-payment-planned-test',
            type: 'Object Base Component',
            label: 'Bm Contract Payment Planned Test',
            testCases: [
                {
                    key: 'local-basic',
                    label: 'Local – Basic',
                    description: 'Local JSON test data',
                    testCaseData: [
                        {
                            id: 1,
                            name: 'Case A',
                            json: JSON.stringify(contractPaymentPlannedTestA),
                            dataType: 0,
                            type: TestCaseDataType.local,
                        },
                        {
                            id: 2,
                            name: 'Case B',
                            json: JSON.stringify(contractPaymentPlannedTestB),
                            dataType: 0,
                            type: TestCaseDataType.local,
                        }
                    ]
                },
            ] as any
        },
        {
            key: 'CustomerBillingAccountDunningAssignPaymentsTestComponent',
            component: CustomerBillingAccountDunningAssignPaymentsTestComponent,
            selector: 'customer-billing-account-dunning-assign-payments-test-component',
            type: 'Component',
            label: 'Bm Customer Dunning Assign payment test',
            testCases: [
                {
                    key: 'local-basic',
                    label: 'Local – Basic',
                    description: 'Local JSON test data',
                    testCaseData: [
                        {
                            id: 1,
                            name: 'Case A',
                            json: JSON.stringify(DunningAssignPaymentTestDataA),
                            dataType: 0,
                            type: TestCaseDataType.local,
                        },

                    ]
                },
            ] as any
        },
        {
            key: 'BmPaymentPlanTestComponent',
            component: BmPaymentPlanTestComponent,
            selector: 'bm-payment-plan-test',
            type: 'Component',
            label: 'Bm Payment Plan Test Component',
            testCases: [
                {
                    key: 'MOCK_DUNNING_DATA_1',
                    label: 'MOCK_DUNNING_DATA_1',
                    description: 'MOCK_DUNNING_DATA_1',
                    testCaseData: [
                        {
                            id: 1,
                            name: 'Case A',
                            json: JSON.stringify(MOCK_DUNNING_DATA_1),
                            dataType: 0,
                            type: TestCaseDataType.local,
                        }
                    ]
                },
                {
                    key: 'MOCK_DUNNING_DATA_2',
                    label: 'MOCK_DUNNING_DATA_2',
                    description: 'MOCK_DUNNING_DATA_2',
                    testCaseData: [
                        {
                            id: 1,
                            name: 'Case A',
                            json: JSON.stringify(MOCK_DUNNING_DATA_2),
                            dataType: 0,
                            type: TestCaseDataType.local,
                        }
                    ]
                },
                {
                    key: 'MOCK_DUNNING_DATA_3',
                    label: 'MOCK_DUNNING_DATA_3',
                    description: 'MOCK_DUNNING_DATA_3',
                    testCaseData: [
                        {
                            id: 1,
                            name: 'Case A',
                            json: JSON.stringify(MOCK_DUNNING_DATA_3),
                            dataType: 0,
                            type: TestCaseDataType.local,
                        }
                    ]
                },
                {
                    key: 'MOCK_DUNNING_DATA_4',
                    label: 'MOCK_DUNNING_DATA_4',
                    description: 'MOCK_DUNNING_DATA_4',
                    testCaseData: [
                        {
                            id: 1,
                            name: 'Case A',
                            json: JSON.stringify(MOCK_DUNNING_DATA_4),
                            dataType: 0,
                            type: TestCaseDataType.local,
                        }
                    ]
                },
            ] as any
        },


    ]
};

export const BM_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: bmModuleEntry, multi: true}
];